import {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {recordPageView} from './analytics';

export default function AnalyticsRoute() {
    const {pathname} = useLocation();
    useLayoutEffect(() => { recordPageView(); }, [pathname]);
    return null;
}
